<template>
  <div class="landing-page-wrapper">
    <div class="landingpage-bg">
      <img
        class="img-landingpage-bg"
        src="../../../assets/img/landingpage-bg.png"
        alt=""
      />
    </div>
    <div class="landing-top-container">
      <div class="landing-logo">
        <img
          src="../../../assets/img/isupplier-logo.png"
          class="img-landing-logo"
          alt=""
        />
      </div>
      <div class="landing-logo">
        <img
          src="../../../assets/img/logo-smm.png"
          class="img-landing-smm-logo"
          alt=""
        />
      </div>
    </div>
    <div class="landing-container">
      <!-- <div class="landing-left">
        <div class="landing-class">
          <div class="class-list">
            <label class="class-label" for="data">DATA</label>
            <input
              class="class-radio"
              type="radio"
              name="data"
              value="data"
              v-model="pick"
            />
          </div>
          <div class="class-list">
            <label class="class-label" for="k3l">K3L</label>
            <input
              class="class-radio"
              type="radio"
              name="k3l"
              value="k3l"
              v-model="pick"
            />
          </div>
          <div class="class-list">
            <label class="class-label" for="kplh">KPLH</label>
            <input
              class="class-radio"
              type="radio"
              name="kplh"
              value="kplh"
              v-model="pick"
            />
          </div>
        </div>
      </div> -->
      <div class="landing-right">
        <div class="step-indicator">
          <div class="step-wrapper">
            <div
              :class="
                $store.state.landingpage.activeLanding == 'instruction'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
              @click="jumpTo('instruction')"
            >
              1
            </div>
            <div class="step-hr-start"></div>
            <div class="step-name">Registrasi</div>
          </div>
          <div class="step-wrapper">
            <div
              @click="jumpTo('profiles')"
              :class="
                $store.state.landingpage.activeLanding == 'profile' ||
                $store.state.landingpage.activeLanding == 'profilebu'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
            >
              2
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Profil</div>
          </div>
          <div class="step-wrapper">
            <div
              @click="jumpTo('alamat')"
              :class="
                $store.state.landingpage.activeLanding == 'alamat' ||
                $store.state.landingpage.activeLanding == 'alamatbu'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
            >
              3
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Alamat</div>
          </div>
          <div class="step-wrapper">
            <div
              @click="jumpTo('bank')"
              :class="
                $store.state.landingpage.activeLanding == 'bank' ||
                $store.state.landingpage.activeLanding == 'bankbu'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
            >
              4
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Bank</div>
          </div>
          <div class="step-wrapper">
            <div
              @click="jumpTo('afiliasi')"
              :class="
                $store.state.landingpage.activeLanding == 'afiliasi' ||
                $store.state.landingpage.activeLanding == 'afiliasibu'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
            >
              5
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Afiliasi</div>
          </div>
          <div class="step-wrapper">
            <div
              @click="jumpTo('legaldoc')"
              :class="
                $store.state.landingpage.activeLanding == 'legalitas' ||
                $store.state.landingpage.activeLanding == 'legalitasbu'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
            >
              6
            </div>
            <div class="step-hr-mid"></div>
            <div class="step-name">Dokumen Legal</div>
          </div>
          <div class="step-wrapper">
            <div
              @click="jumpTo('selesai')"
              :class="
                $store.state.landingpage.activeLanding == 'selesai'
                  ? 'step-number-white'
                  : 'step-number-red'
              "
            >
              7
            </div>
            <div class="step-hr-end"></div>
            <div class="step-name">Selesai</div>
          </div>
        </div>
        <div class="landing-form">
          <div class="landing-box">
            <!-- <router-view /> -->
            <keep-alive>
              <component :is="activeLanding" />
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
    <div class="landing-footer-container">
      <span style="color:#fff; text-align:center"
        >Copyright© {{ new Date().getFullYear()}}
        <span style="color:#fff; font-weight:bold">Sinarmas Mining</span>. All
        Rights reserved</span
      >
    </div>
    <GlobalLoading
      v-if="
        $store.state.modalStore.isGlobalLoading ||
          $store.state.level1.isLoading ||
          $store.state.landingpage.globalLoading
      "
    />
    <Notif v-if="$store.state.showModalNotif" />
  </div>
</template>
<script>
import { api } from '@/services/config'
import axios from 'axios'
export default {
  name: 'instruction',
  data() {
    return {
      pick: '',
      errorMessage: null,
    }
  },
  components: {
    GlobalLoading: () => import('@/components/V2/GlobalLoading.vue'),
    Notif: () => import('@/components/modal/Notification.vue'),
  },
  async created() {
    // const query = this.$get(this.$route, 'params.session')
    // const req = this.$get(this.$route, 'params.id')
    // const user = this.$get(this.$route, 'params.user')

    // if (user) {
    //   await this.$store.commit('landingpage/SET_STATE_DATA', {
    //     name: 'userid',
    //     value: user,
    //   })
    // }
    // await this.setPage(query, req)
  },

  computed: {
    activeLanding: function() {
      const tab = this.$store.state.landingpage.activeLanding

      switch (tab) {
        case 'instruction':
          return () => import('@/views/Pra-Legal/Instruction.vue')
          break
        case 'profilebu':
          return () => import('@/views/Pra-Legal/ProfilBU.vue')
          break
        case 'alamat':
          return () => import('@/views/Pra-Legal/Alamat.vue')
          break
        case 'bank':
          return () => import('@/views/Pra-Legal/Bank.vue')
          break
        case 'afiliasi':
          return () => import('@/views/Pra-Legal/Afiliasi.vue')
          break
        case 'legalitas':
          return () => import('@/views/Pra-Legal/Legalitas.vue')
          break
        case 'legalitasbu':
          return () => import('@/views/Pra-Legal/LegalitasBU.vue')
          break
        case 'selesai':
          return () => import('@/views/Pra-Legal/Selesai.vue')
          break
        default:
          break
      }
    },
  },
  methods: {
    jumpTo(name) {
      const {
        query,
        start_step,
        profil_step,
        alamat_step,
        bank_step,
        afiliasi_step,
        legal_step,
        end_step,
      } = this.$store.state.landingpage

      if (name == 'instruction') {
        if (start_step) {
          this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'instruction')
        } else {
          this.sendNotif()
        }
      }

      if (name == 'profiles') {
        if (profil_step) {
          this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'profilebu')
        } else {
          this.sendNotif()
        }
      }

      if (name == 'alamat') {
        if (alamat_step) {
          this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'alamat')
        } else {
          this.sendNotif()
        }
      }
      if (name == 'bank') {
        if (bank_step) {
          this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'bank')
        } else {
          this.sendNotif()
        }
      }
      if (name == 'afiliasi') {
        if (afiliasi_step) {
          this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'afiliasi')
        } else {
          this.sendNotif()
        }
      }
      if (name == 'legaldoc') {
        if (legal_step) {
          if (query == 'bu')
            this.$store.commit(
              'landingpage/SET_LANDINGPAGE_FORM',
              'legalitasbu'
            )
          if (query == 'perorangan')
            this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'legalitas')
        } else {
          this.sendNotif()
        }
      }
      if (name == 'selesai' && end_step) {
        if (end_step) {
          this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'selesai')
        } else {
          this.sendNotif()
        }
      }
    },
    sendNotif() {
      this.$store.commit(
        'SET_NOTIF',
        'Selesaikan Step Sebelumnya Terlebih Dahulu.'
      )
    },
    async setPage(query, req) {
      try {
        let url = ''
        if (query) url = `${api}/api/v1/request/session/${query}`
        if (req) url = `${api}/api/v1/request/detailvendor/${req}`

        let pendaftaran_id = null
        let bidang_usaha = ''
        let bidang_usaha_id = null
        let nama_vendor = ''
        let type_pendaftaran_id = null
        let register_gems = null
        let register_bce = null
        let register_bkes = null
        let request_id = null
        let tujuan_pendaftaran_id = null

        const { data } = await axios({
          method: 'GET',
          url,
        })

        let dataStore = []

        if (req) {
          dataStore = data.data.items[0]
        }
        if (query) {
          dataStore = data.data
        }

        if (data && data.status == 'success') {
          pendaftaran_id = dataStore && dataStore.id
          bidang_usaha =
            dataStore && dataStore.bidang_usaha_id == 1 ? 'bu' : 'perorangan'
          bidang_usaha_id = dataStore && dataStore.bidang_usaha_id
          type_pendaftaran_id = dataStore && dataStore.type_pendaftaran_id
          register_gems = dataStore && dataStore.register_gems
          register_bce = dataStore && dataStore.register_bce
          register_bkes = dataStore && dataStore.register_bkes
          nama_vendor = dataStore && dataStore.nama_vendor
          request_id = dataStore && dataStore.request_id
          tujuan_pendaftaran_id = this.$get(
            data,
            'data.request.tujuan_pendaftaran'
          )
          if (type_pendaftaran_id == 1) {
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'choosedCountry',
              value: {
                id: 63,
                kode_negara: 'ID',
                negara: 'Indonesia',
                kode_telepon: '62',
                mata_uang: 'Rupiah ',
                kode_mata_uang: 'IDR',
                createdAt: '2021-12-07T07:15:27.000Z',
                updatedAt: '2021-12-07T07:15:27.000Z',
                deletedAt: null,
              },
            })
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'phoneCode',
              value: '+62',
            })
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'mataUang',
              value: 'IDR',
            })
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'phoneDirektur',
              value: '+62',
            })
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'phoneKomisaris',
              value: '+62',
            })
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'phonePic',
              value: '+62',
            })
          }

          await this.$store.commit(
            'landingpage/SET_LANDING_ROUTER',
            bidang_usaha
          )
          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'request_id',
            value: request_id,
          })
          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'pendaftaran_id',
            value: pendaftaran_id,
          })
          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'tujuan_pendaftaran_id',
            value: tujuan_pendaftaran_id,
          })
          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'vendorName',
            value: nama_vendor,
          })
          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'pemilikBank',
            value: nama_vendor,
          })
          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'bidang_usaha_id',
            value: bidang_usaha_id,
          })
          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'type_pendaftaran_id',
            value: type_pendaftaran_id,
          })

          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'register_gems',
            value: register_gems,
          })
          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'register_bce',
            value: register_bce,
          })
          await this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'register_bkes',
            value: register_bkes,
          })

          await this.checkRoutePath(request_id)
        }
      } catch (error) {
        await this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
        await this.$router.push('/')
      }
    },
    async checkRoutePath(request_id) {
      let pageName = this.$route.path
      if (pageName && pageName.split('/')[1] == 'review-landing-page') {
        await this.$store.commit('landingpage/SET_NEED_REVIEW')
        await this.getInformasi(request_id)
      }

      if (pageName && pageName.split('/')[1] == 'review-from-landing-page') {
        await this.$store.commit('landingpage/SET_NEED_REVIEW')
        await this.getInformasi(request_id)
      }
    },
    async getInformasi(request_id) {
      const url = `${api}/api/v1/d-vendor-informasi?request_id=${request_id}`

      await this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'globalLoading',
        value: true,
      })
      await axios({
        method: 'GET',
        url,
      })
        .then(({ data }) => {
          let informasi = data.data
          console.log('informasi: ', informasi)
          this.$store.commit('landingpage/UPDATE_INFORMASI', informasi)
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'globalLoading',
            value: false,
          })
          this.getLegalitas(request_id)
        })
        .catch(error => {
          // do nothing
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'globalLoading',
            value: false,
          })
        })
    },
    getLegalitas(request_id) {
      const url = `${api}/api/v1/d-vendor-legal-document?request_id=${request_id}`
      axios({
        method: 'GET',
        url,
      })
        .then(({ data }) => {
          console.log('data legal: ', data.data)
          let legal = data.data
          this.$store.commit('landingpage/UPDATE_LEGAL', legal)
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'globalLoading',
            value: false,
          })
        })
        .catch(error => {
          // do nothing
          this.$store.commit('landingpage/SET_STATE_DATA', {
            name: 'globalLoading',
            value: false,
          })
        })
    },
  },
}
</script>
